import { GatsbyImage } from "gatsby-plugin-image";

import { Box, Heading, Link, Stack } from "@vinomofo/components";

import { BannerButton, BannerProps } from "../banner";

export const HTMLBanner = ({
  banner,
}: {
  banner: BannerProps;
}): JSX.Element => {
  const {
    htmlBannerTitle,
    tagline,
    bodyTextColor,
    backgroundImage,
    backgroundColor,
    titleColor,
    cta,
    linkTo,
  } = banner;

  const ctaLink = linkTo?.url;

  return (
    <Box
      display="flex"
      width="100%"
      height={["auto", "400px"]}
      flexDirection={["column-reverse", "row-reverse"]}
      backgroundColor={backgroundColor}
    >
      <Box
        width={["100%", "50%"]}
        textAlign={"left"}
        marginRight={"auto"}
        marginLeft={0}
        height={"100%"}
        minHeight="250px"
        position="relative"
        padding={5}
      >
        <GatsbyImage
          image={backgroundImage}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center center",
          }}
          alt=""
        />
      </Box>
      <Box
        width={["100%", "50%"]}
        height="100%"
        position="relative"
        display="flex"
        alignItems="center"
        padding={5}
        textAlign={["center", "left"]}
      >
        <Stack space={3}>
          <Heading color={bodyTextColor} variant="xxs">
            {tagline}
          </Heading>
          <Heading variant="xl" color={titleColor}>
            {htmlBannerTitle}
          </Heading>
          <Link to={ctaLink}>
            <BannerButton
              variant="outline"
              borderColor={titleColor}
              color="white"
              backgroundColor={backgroundColor}
            >
              {cta}
            </BannerButton>
          </Link>
        </Stack>
      </Box>
    </Box>
  );
};
